// Vida en Orden — formato del label de una TAREA dentro del Calendario.
// Separado del componente para poder testearlo con Node puro (sin React).
//
// Regla:
//   • task.due_time presente → título + chip " — 🕚 HH:MM"
//   • task.due_time ausente/null/"" → sólo el título (comportamiento previo)
//
// `timeSuffix` viene con el separador " — " incluido para que el consumidor
// lo concatene tal cual (o lo renderice como <span>).

function calendarTaskLabelParts(task) {
  if (!task) return { title: '', timeSuffix: null };
  const title = task.title || '';
  const t = task.due_time;
  if (typeof t === 'string' && t.trim() !== '') {
    return { title, timeSuffix: ` — 🕚 ${t.trim()}` };
  }
  return { title, timeSuffix: null };
}

module.exports = { calendarTaskLabelParts };
